import { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Text } from '../../components/styledComponents';
import DashboardWrapper from '../../components/dashboard/dashboardWrapper/DashboardWrapper';
import PaymentTable from '../../components/tables/PaymentTable';
import styles from '../../styles/payments.module.css';
import { getCreatorCompletedPayments, getCreatorPendingPayments } from '../../services/dashboard.service';
// import CustomDatePicker from '../../components/dashboard/customDatePicker/CustomDatePicker';
import LoaderSvg from '../../assets/images/loader.svg';

export default function PaymentHistory() {
  const [searchParams] = useSearchParams();
  const [currentTab, setCurrentTab] = useState<string | null>(
    searchParams.get('tab') ? searchParams.get('tab') : 'pending'
  );

  const [pendingPaymentsData, setPendingPaymentsData] = useState([]);
  const [completedPaymentsData, setCompletedPaymentsData] = useState([]);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  // const [dateRange, setDateRange] = useState<any>([]);
  // const [selectedDays, setSelectedDays] = useState<number>(7);
  // const [showDatePicker, setShowDatePicker] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleTabChange = (tab: string) => {
    setCurrentTab(tab);
    navigate(`?tab=${tab}`);
  };

  const fetchPendingPayments = async () => {
    const response = await getCreatorPendingPayments();
    if (response.status) {
      setPendingPaymentsData(response.data?.pendingPayments || []);
      setIsLoading(false);
    }
  };
  const fetchCompletedPayments = async () => {
    const response = await getCreatorCompletedPayments();
    if (response.status) {
      setCompletedPaymentsData(response.data?.completedPayments);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchPendingPayments();
    fetchCompletedPayments();
  }, []);

  return (
    <DashboardWrapper heading="Payment History">
      <div className="top-bar">
        <div className={styles.tabsContainer}>
          <Text
            fontSize="14px"
            color={currentTab === 'pending' ? 'var(--saral-purple)' : 'var(--dark-grey)'}
            onClick={() => handleTabChange('pending')}
          >
            Pending
          </Text>
          <span>|</span>
          <Text
            fontSize="14px"
            color={currentTab === 'completed' ? 'var(--saral-purple)' : 'var(--dark-grey)'}
            onClick={() => handleTabChange('completed')}
          >
            Completed
          </Text>
        </div>
        <div>
          {/* <CustomDatePicker
            selectedDays={selectedDays}
            showDatePicker={showDatePicker}
            dateRange={dateRange}
            setDateRange={setDateRange}
            setSelectedDays={setSelectedDays}
            setShowDatePicker={setShowDatePicker}
          /> */}
        </div>
      </div>

      {isLoading ? (
        <div className={styles.loaderDiv}>
          <img src={LoaderSvg} alt="loader" width={100} />
        </div>
      ) : (
        <>
          {currentTab === 'pending' && <PaymentTable tableBody={pendingPaymentsData} currentTab={currentTab} />}
          {currentTab === 'completed' && <PaymentTable tableBody={completedPaymentsData} currentTab={currentTab} />}
        </>
      )}
    </DashboardWrapper>
  );
}
